import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Container,
  Dropdown,
  Image,
  Nav,
  Navbar,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Logo from "assets/images/logo-inner.svg";
import dummyIcon from "assets/images/dumy-user-icon.svg";
import CalendraIconGray from "assets/images/calendra-icon.svg";
import {
  getNewNotificationCount,
  logout,
  markNotificationRead,
} from "../../../services/authService";
import { SvgIcons } from "../../common/SvgIcons";
import "./header.scss";
import storage from "../../../helpers/storage";
import { nameBasedRoutes } from "../../../router/public";
import { nameBasedProtectedRoutes } from "../../../router/protected";
import ImageTag from "components/common/ImageTag";
import { navBarTags } from "constants/constants";
import { MyContext } from "MyProvider";
import Notification from "./Notification";
import { ManageSignature } from "pages/Inspector/Profile/ManageSignature";

/**
 * Header Component for the app
 *
 * @returns {*}
 */
export const Header = () => {
  const navigate = useNavigate();
  const [roleCustomer, setroleCustomer] = useState(false);
  const [roleInspector, setroleInspector] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [isNotificationCount, setIsNotificationCount] = useState(0);
  const [isNewNotification, setIsNewNotification] = useState(false);
  const [dropdownOpenBell, setDropdownOpenBell] = useState(false);
  const [menuCollapse, setMenuCollapse] = useState(false)
  const [showManageSign, setShowManageSign] = useState(false)
  const userInformation: {
    id: number;
    role: string;
    first_name: string;
    last_name: string;
    company_name: string;
    parent_id: number;
  } = storage.getData("user-info");
  const userName = userInformation.first_name + " " + userInformation.last_name;
  const userId = userInformation.id;

  const role = userInformation ? userInformation?.role : "guest";
  let headerClass = "dashboard-header";
  useEffect(() => {
    if (storage.getToken() != null) {
      if (role == "CUSTOMER") {
        setroleCustomer(true);
        setroleInspector(false);
      } else {
        headerClass = "inspector-header";
        setroleCustomer(false);
        setroleInspector(true);
      }
    }
  }, []);

  const logOut = async () => {
    logout({ refreshToken: storage.getRefreshToken() })
      .then((response) => {
        localStorage.removeItem("SI_refreshToken");
        localStorage.removeItem("SI_token");
        localStorage.removeItem("user-info");
        navigate(nameBasedRoutes.login.path);
      })
      .catch((error) => {});
    localStorage.removeItem("PREVIOUS_INSPECTIONS");  
    localStorage.removeItem("SI_refreshToken");
    localStorage.removeItem("SI_token");
    localStorage.removeItem("user-info");
    navigate(nameBasedRoutes.login.path);
  };

  const handleManageSignature = () =>{
    setShowManageSign(!showManageSign)
  }

  

  const profile = async () => {
    if (roleCustomer) {
      userInformation.parent_id
        ? navigate(nameBasedProtectedRoutes.Userprofile.path)
        : navigate(nameBasedProtectedRoutes.profile.path);
    } else {
      navigate(nameBasedProtectedRoutes.iprofile.path);
    }
  };

  const [activeNavItem, setActiveNavItem] = useState(navBarTags.dashboard);

  const handleNavItemClick = (eventKey) => {
    setActiveNavItem(eventKey);
  };

  const MINUTE_MS = 30000; // 60000 Miliseconds is equal to 1 minute
  useEffect(() => {
    newNotification();
    const interval = setInterval(() => {
      newNotification();
    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, []);

  // Fetch notification list
  const newNotification = () => {
    getNewNotificationCount({ id: userId }).then((response) => {
      setNotificationCount(response?.data);
      setIsNewNotification(response?.data ? true : false);
      setIsNotificationCount(response?.notificationCount);
    });
  };

  // Toggle notification list
  const toggleBell = () => {
    setDropdownOpenBell((prevState) => !prevState);
    if (!dropdownOpenBell) {
      // Mark Notification as Read
      readNotification();
    }
  };

  // mark all notification as read
  const readNotification = () => {
    markNotificationRead({ id: userId }).then((response) => {
      setNotificationCount(0);
      setIsNewNotification(false);
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentUrl = window.location.pathname;
      if (currentUrl == nameBasedProtectedRoutes.billsAndPayments.path) {
        setActiveNavItem(navBarTags.billsAndPayments);
      } else if (currentUrl == nameBasedProtectedRoutes.inspections.path) {
        setActiveNavItem(navBarTags.inspections);
      } else if (currentUrl == nameBasedProtectedRoutes.faq.path) {
        setActiveNavItem(navBarTags.faq);
      } else if (currentUrl == nameBasedProtectedRoutes.users.path) {
        setActiveNavItem(navBarTags.users);
      } else if (currentUrl == nameBasedProtectedRoutes.AddUser.path) {
        setActiveNavItem(navBarTags.users);
      } else if (currentUrl == nameBasedProtectedRoutes.contactUs.path) {
        setActiveNavItem(navBarTags.contact);
      } else {
        setActiveNavItem(navBarTags.dashboard);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  const { addSecondaryUser } = useContext(MyContext);

  const menuCollapseControll = () =>{
    console.log("yes")
    setMenuCollapse(!menuCollapse)
}
  const redirectDashboard = async () => {
    setMenuCollapse(!menuCollapse)
 
    const currentUrl = window.location.pathname;
    if (
      currentUrl == nameBasedProtectedRoutes.dashborad.path ||
      currentUrl == nameBasedProtectedRoutes.iuserDashboard.path
    ) {
      window.location.reload();
    } else {
      if (roleCustomer) {
        navigate(nameBasedProtectedRoutes.dashborad.path);
      } else {
        navigate(nameBasedProtectedRoutes.iuserDashboard.path);
      }
    }
  };

  
  return (
    <header className={`header-section ${headerClass}`}>
      <Navbar bg="white" variant="light" className="py-3" expand="lg">
        <Container className="">
          <Navbar.Brand>
            <div
              onClick={redirectDashboard}
              
              className="text-link"
            >
              <Image
                className="img-fluid"
                src={Logo}
                alt="Logo"
                width={180}
                height={40}
              />
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={menuCollapseControll} />
          <Navbar.Collapse id="basic-navbar-nav" in={menuCollapse} >
            <Nav
              className="align-items-lg-center justify-content-between navbar-nav w-100 ms-xl-5 ps-xl-5"
              onSelect={handleNavItemClick}
            >
              {roleCustomer && (
                <div className="d-lg-flex inspector-menu-hide">
                  <Nav.Link
                    eventKey={navBarTags.dashboard}
                    active={activeNavItem === navBarTags.dashboard}
                    href="javascript:void(0)"
                    onClick={() => redirectDashboard()}
                    className="fs-15 fw-semibold position-relative"
                  >
                    Dashboard
                  </Nav.Link>
                  <Nav.Link
                    eventKey={navBarTags.billsAndPayments}
                    active={activeNavItem === navBarTags.billsAndPayments}
                    href="javascript:void(0)"
                    onClick={() =>
                     {   menuCollapseControll()
                      navigate(nameBasedProtectedRoutes.billsAndPayments.path)}
                    }
                    className="fs-15 fw-semibold position-relative"
                  >
                    Bills & Payments
                  </Nav.Link>
                  <Nav.Link
                    eventKey={navBarTags.inspections}
                    active={activeNavItem === navBarTags.inspections}
                    href="javascript:void(0)"
                    onClick={() => {
                       menuCollapseControll()
                      navigate(nameBasedProtectedRoutes.inspections.path)
                    }}
                    className="fs-15 fw-semibold position-relative"
                  >
                    Inspections
                  </Nav.Link>
                  <Nav.Link
                    eventKey={navBarTags.faq}
                    active={activeNavItem === navBarTags.faq}
                    href="javascript:void(0)"
                    onClick={() => { menuCollapseControll(); navigate(nameBasedProtectedRoutes.faq.path)}}
                    className="fs-15 fw-semibold position-relative "
                  >
                    FAQ
                  </Nav.Link>
                  <Nav.Link
                    eventKey={navBarTags.contact}
                    active={activeNavItem === navBarTags.contact}
                    href="javascript:void(0)"
                    onClick={() =>
                     {  menuCollapseControll(); 
                      navigate(nameBasedProtectedRoutes.contactUs.path)}
                    }
                    className="fs-15 fw-semibold position-relative"
                  >
                    Contact
                  </Nav.Link>
                </div>
              )}

              {roleInspector && (
                <div className="d-lg-flex">
                  <Nav.Link
                    eventKey={navBarTags.dashboard}
                    active={activeNavItem === navBarTags.dashboard}
                    href="javascript:void(0)"
                    onClick={() => redirectDashboard()}
                    className="fs-15 fw-semibold position-relative"
                  >
                    Dashboard
                  </Nav.Link>{" "}
                </div>
              )}
              <div className="d-lg-flex">
                <Dropdown
                  className="notificationDropdown me-md-2 me-1"
                  onClick={() => toggleBell()}
                >
                  <Dropdown.Toggle
                    variant="link"
                    id="dropdown-notification"
                    className={`fs-15 fw-bold text-decoration-none p-0 position-relative w-40 h-40 rounded-circle d-inline-flex align-items-center justify-content-center ${
                      isNewNotification ? "dropdown-toggle-active" : ""
                    }`}
                  >
                    {SvgIcons.bellIcon}{" "}
                    {isNewNotification ? (
                      <span className="position-absolute top-0 end-0 rounded-circle bg-danger p-1 notifiyDot">
                        <span className="visually-hidden">unread messages</span>
                      </span>
                    ) : (
                      ""
                    )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    align="end"
                    className="mh-300 scroll-content"
                    id="scrollableDiv"
                  >
                    <Notification
                      notificationCount={notificationCount}
                      isNotificationCount={isNotificationCount}
                    />
                  </Dropdown.Menu>
                  <Dropdown.Menu align="end" className="d-none">
                    <Dropdown.Item>
                      <div className="notification-box-item">
                        <div className="fs-13 fw-semibold gray-color">
                          <ImageTag
                            className="calendra-icon"
                            src={CalendraIconGray}
                          />
                          12-16-2022
                        </div>
                        <div className="fs-15 fw-bold text-333">
                          SR No. #9875465 Completed
                        </div>
                        <div className="fs-15 fw-bold link-color">
                          SR completed
                        </div>
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <div className="notification-box-item">
                        <div className="fs-13 fw-semibold gray-color">
                          <ImageTag
                            className="calendra-icon"
                            src={CalendraIconGray}
                          />
                          12-16-2022
                        </div>
                        <div className="fs-15 fw-bold text-default">
                          SR No. #9875465 Completed
                        </div>
                        <div className="fs-15 fw-bold link-color">
                          SR approved
                        </div>
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <div className="notification-box-item">
                        <div className="fs-13 fw-semibold gray-color">
                          <ImageTag
                            className="calendra-icon"
                            src={CalendraIconGray}
                          />
                          12-16-2022
                        </div>
                        <div className="fs-15 fw-bold text-default">
                          SR No. #9875465 Completed
                        </div>
                        <div className="fs-15 fw-bold link-color">
                          Inspection done
                        </div>
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <div className="notification-box-item">
                        <div className="fs-13 fw-semibold gray-color">
                          <ImageTag
                            className="calendra-icon"
                            src={CalendraIconGray}
                          />
                          12-16-2022
                        </div>
                        <div className="fs-15 fw-bold text-default">
                          SR No. #9875465 Completed
                        </div>
                        <div className="fs-15 fw-bold link-color">
                          Certificate due
                        </div>
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <div className="vr mx-2 mx-md-4 d-none d-lg-block"></div>
                {showManageSign && <ManageSignature showSign={showManageSign} handleSignModalClose={handleManageSignature}/>}
                <Dropdown className="profileDropdown mt-2 mt-lg-0  ms-lg-1">
                  <Dropdown.Toggle
                    variant="link"
                    id="dropdown-profile"
                    className="border-0 fs-15 fw-semibold text-decoration-none p-0"
                  >
                    <Image
                      className="object-fit-cover rounded-circle"
                      src={dummyIcon}
                      alt="Profile Image"
                      width={46}
                      height={46}
                    />
                    <span className="align-middle  d-inline-block ms-1 px-2 text-truncate mw-150">
                      {userName}
                    </span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu align="end" className="profile-dropdown">
                    {roleCustomer && (
                      <>
                        <Dropdown.Item onClick={profile} className="pe-1 ps-1">
                          <div className="d-flex p-2 pe-3 ps-3 profile-bg-light br-5  ">
                            {" "}
                            <i className="fas fa-city me-2 icon-color mt-1"></i>{" "}
                            <div className="company-color  fs-11">
                              COMPANY <br />{" "}
                              <span className="link-color fs-15 fw-bold">
                                {userInformation?.company_name}{" "}
                              </span>
                            </div>
                          </div>{" "}
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={profile}
                          className="fs-15 fw-semibold pt-2 pb-2 "
                        >
                          <i className="fa fa-user me-2 icon-color"></i> Profile
                        </Dropdown.Item>
                      </>
                    )}
                    {addSecondaryUser && (
                      <Dropdown.Item
                        onClick={() =>
                          navigate(nameBasedProtectedRoutes.users.path)
                        }
                        className="fs-15 fw-semibold pt-2 pb-2"
                      >
                        <i className="fa fa-users me-2 icon-color "></i>Users
                      </Dropdown.Item>
                    )}

                   {roleInspector &&  <Dropdown.Item
                      onClick={handleManageSignature}
                      className="fs-15 fw-semibold pt-2 pb-2"
                    >
                      <i className="fas fa-signature me-2 icon-color"></i>{" "}
                      Manage Signature  
                    </Dropdown.Item>}
                    <Dropdown.Item
                      onClick={logOut}
                      className="fs-15 fw-semibold pt-2 pb-2"
                    >
                      <i className="fas fa-sign-out-alt me-2 icon-color"></i>{" "}
                      Logout  
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};
